<template>
  <el-dialog 
    :title="$t('communitySpaceManage.openTimeTitle')" 
    :visible.sync="visible"
    width="70%"
  >
    <el-row :gutter="20">
      <el-col :span="8" v-for="(item, index) in openTimes" :key="index">
        <div class="time-item">
          <span>{{ item.hours }}{{ $t('common.hour') }}</span>
          <el-select v-model="item.isOpen" @change="updateOpenTime(item)" style="width:100%;margin-bottom:10px;">
            <el-option 
              :label="$t('communitySpaceManage.status1001')" 
              value="Y" 
            />
            <el-option 
              label="VIP预约" 
              value="VIP" 
            />
            <el-option 
              :label="$t('communitySpaceManage.status2002')" 
              value="N" 
            />
          </el-select>
          <div class="max-persons-row">
            <span class="max-persons-label">最大预约数:</span>
            <el-input-number 
              v-model="item.maxPersons" 
              :min="1" 
              :max="100" 
              size="mini"
              @change="updateOpenTime(item)"
            ></el-input-number>
          </div>
          <div v-if="item.bookedCount !== undefined" class="booked-count">
            已预约数: {{ item.bookedCount }}
          </div>
        </div>
      </el-col>
    </el-row>
    
    <div slot="footer" class="dialog-footer">
      <el-button @click="visible = false">
        {{ $t('common.close') }}
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import { updateCommunitySpaceOpenTime } from '@/api/community/communitySpaceManageApi'

export default {
  name: 'EditCommunitySpaceOpenTime',
  data() {
    return {
      visible: false,
      openTimes: []
    }
  },
  methods: {
    open(space) {
      this.openTimes = space.openTimes || []
      this.visible = true
    },
    
    async updateOpenTime(item) {
      try {
        await updateCommunitySpaceOpenTime({
          timeId: item.timeId,
          isOpen: item.isOpen,
          maxPersons: item.maxPersons || 1,
          isVip: item.isOpen === 'VIP' ? 'Y' : 'N'
        })
        this.$message.success(this.$t('common.operationSuccess'))
      } catch (error) {
        console.error('更新开放时间失败:', error)
      }
    }
  }
}
</script>

<style scoped>
.time-item {
  margin-bottom: 15px;
  padding: 10px;
  border: 1px solid #eee;
  border-radius: 4px;
}
.time-item span {
  display: block;
  margin-bottom: 5px;
  font-weight: bold;
}
.max-persons-row {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 8px;
}
.max-persons-label {
  font-size: 12px;
  color: #666;
  flex-shrink: 0;
}
.booked-count {
  margin-top: 6px;
  font-size: 12px;
  color: #409eff;
}
</style>